import Cookies from "js-cookie";
import { REDIRECT_COOKIE_NAME } from "../constants";
/**
 * Redirect path cookie
 * OneLogin does not have a system to handle the app redirect after the login flow is done
 * This is why we store the app redirect path to a cookie before the login flow redirects
 * and clear it once the flow is completed
 */
export function getRedirectPath() {
    const cookie = Cookies.get(REDIRECT_COOKIE_NAME) || undefined;
    return cookie;
}
export function setRedirectPath(location) {
    var _a, _b, _c, _d;
    const path = `${location.pathname}${(_a = location.search) !== null && _a !== void 0 ? _a : ""}${(_b = location.hash) !== null && _b !== void 0 ? _b : ""}`;
    Cookies.set(REDIRECT_COOKIE_NAME, `${location.pathname}${(_c = location.search) !== null && _c !== void 0 ? _c : ""}${(_d = location.hash) !== null && _d !== void 0 ? _d : ""}`);
    return path;
}
export function clearRedirectPath() {
    Cookies.remove(REDIRECT_COOKIE_NAME);
}
//# sourceMappingURL=redirect.js.map